import { BasePressTooltipProps } from './base-press-tooltip/BasePressTooltip.types';
import { TBaseButtonProps } from '../buttons/base-button/BaseButton.types';

export type TooltipProps = Pick<
  BasePressTooltipProps,
  'TooltipContent' | 'containerStyle' | 'backgroundColor' | 'width' | 'height' | 'position' | 'onPress' | 'tooltipID'
> &
  Omit<TBaseButtonProps, 'onPress'>;

export enum TooltipPosition {
  TOP,
  BOTTOM,
  LEFT,
  RIGHT,
}
